import { ApolloError, useQuery } from '@apollo/client';
import MealListQuery from './CookbookMealListQuery';
import {
  CookbookMealListEdge,
  MealsSearchCriteriaInputType,
  SearchMealListQueryResult,
  SearchVariables,
} from '../types';

type result = {
  loading: boolean;
  error?: ApolloError;
  meals?: CookbookMealListEdge[];
  refetch?: (variables: SearchVariables) => Promise<any>;
};

interface IMealListConnectorApollo {
  children: (result: result) => JSX.Element;
  searchCriteria?: MealsSearchCriteriaInputType;
}

const MealListConnectorApolloConnectorApollo: React.FC<IMealListConnectorApollo> = ({
  children,
  searchCriteria,
}) => {
  const { loading, error, data, refetch } = useQuery<SearchMealListQueryResult, SearchVariables>(
    MealListQuery,
    {
      variables: { searchCriteria },
    }
  );

  const result: result = {
    loading,
    error,
    refetch,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.meals = data?.cookbook.meals.edges;
  }
  return children(result);
};

export default MealListConnectorApolloConnectorApollo;
